import { i18n } from '../i18n'
import type { TranslationKey } from '../types/TranslationKey'
export const t = (key: string, params?: Record<string, unknown> | unknown[]) =>
  params === undefined ? i18n.global.t(key) : (i18n.global.t as any)(key, params)
export const tt = (message?: TranslationKey) =>
  message ? t(message.key, (message as any).params ?? {}) : ''
export const tm = <T>(key: string, fallback?: T): T =>
  (i18n.global.tm(key) as unknown as T | undefined) ?? (fallback as T)
